import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { apiConfig } from '@core/conf/b2c-config';
import { defer, Observable, switchMap } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class BasicAuthInterceptor implements HttpInterceptor {
  private readonly apiUrls = Object.entries(environment)
    .filter(([key]) => key.startsWith('apiEndpoint'))
    .map(([, endpoint]) => new URL(String(endpoint), window.location.origin));

  constructor(private readonly msalService: MsalService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isApiRequest(req.url)) {
      return next.handle(req);
    }

    const authReq = req.clone({
      setHeaders: { 'Ocp-Apim-Subscription-Key': environment.serviceSubscriptionKey }
    });
    const account = this.msalService.instance.getActiveAccount() ?? this.msalService.instance.getAllAccounts()[0];

    if (!account) {
      return next.handle(authReq);
    }

    return defer(() => this.msalService.acquireTokenSilent({ account, scopes: apiConfig.scopes })).pipe(
      switchMap(result => next.handle(authReq.clone({ setHeaders: { Authorization: `Bearer ${result.accessToken}` } })))
    );
  }

  private isApiRequest(url: string): boolean {
    const requestUrl = new URL(url, window.location.origin);
    return this.apiUrls.some(apiUrl => {
      const basePath = apiUrl.pathname.replace(/\/$/, '');
      return requestUrl.origin === apiUrl.origin &&
        (requestUrl.pathname === basePath || requestUrl.pathname.startsWith(`${basePath}/`));
    });
  }
}
